var SpriteSymbol = require("svg-baker-runtime/browser-symbol");
var sprite = require("svg-sprite-loader/runtime/browser-sprite.build");
var symbol = new SpriteSymbol({
  "id": "ring-icon-user-spinner",
  "use": "ring-icon-user-spinner-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"ring-icon-user-spinner\"><path d=\"M6.562.875a3.69 3.69 0 1 0 0 7.382 3.664 3.664 0 0 0 .576-.058 4.738 4.738 0 0 1 2.772-2.1A3.675 3.675 0 0 0 6.562.875zm.053 8.553H4.218A4.23 4.23 0 0 0 0 13.647 2.388 2.388 0 0 0 .028 14h7.781a4.622 4.622 0 0 1-1.194-4.572z\" /><path class=\"secondary\" d=\"M12.69 10.667a1.5 1.5 0 1 1-1.523-1.506V7.02a3.638 3.638 0 1 0 3.662 3.646z\" /></symbol>"
});
var result = sprite.add(symbol);
module.exports = "#" + symbol.id